import React from 'react'
import { Menu } from 'semantic-ui-react'
import logo from '../assets/LogoOfficialTransparent.png'

export default ({ user }) => (
    <Menu>
        <Menu.Item header><img src={logo} style={{ width: '9em', margin: '-1.2em -2em' }} /></Menu.Item>
        {user ? 
            <Menu.Menu position='right'>
                <Menu.Item name={user.username} />
            </Menu.Menu>
            : ''
        }
    </Menu>
)


// WEBPACK FOOTER //
// ./src/components/NavBar.js